class TopBarComponent extends HTMLElement {
  connectedCallback() {
    this.messages = Array.from(this.querySelectorAll('.top-bar__message'));
    this.closeButton = this.querySelector('.top-bar__close');
    this.index = 0;
    this.timer = null;

    const speed = parseInt(this.dataset.rotateSpeed, 10);
    this.speed = Number.isNaN(speed) ? 4000 : speed * 1000;

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.dismiss.bind(this));
    }

    // Matches the breakpoint in section-top-bar.css where the messages stop fitting on one row.
    this.mediaQuery = window.matchMedia('(max-width: 989px)');
    this.onViewportChange = this.handleViewportChange.bind(this);
    this.mediaQuery.addEventListener('change', this.onViewportChange);
    this.handleViewportChange();
  }

  disconnectedCallback() {
    this.stopRotation();
    if (this.mediaQuery) this.mediaQuery.removeEventListener('change', this.onViewportChange);
  }

  handleViewportChange() {
    if (this.mediaQuery.matches && this.messages.length > 1) {
      this.startRotation();
    } else {
      this.stopRotation();
    }
  }

  startRotation() {
    if (this.timer) return;

    this.classList.add('top-bar--rotating');
    this.setActiveMessage(0);
    this.timer = setInterval(() => {
      this.setActiveMessage((this.index + 1) % this.messages.length);
    }, this.speed);
  }

  stopRotation() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    this.classList.remove('top-bar--rotating');
    this.messages.forEach((message) => message.classList.remove('is-active'));
  }

  setActiveMessage(index) {
    this.index = index;
    this.messages.forEach((message, i) => message.classList.toggle('is-active', i === index));
  }

  dismiss() {
    this.setAttribute('hidden', '');
    this.stopRotation();

    try {
      localStorage.setItem(`top-bar-dismissed-${this.dataset.sectionId}`, 'true');
    } catch (error) {
      // Storage unavailable (private mode / quota) — dismissal stays for this page view only.
    }
  }
}

if (!customElements.get('top-bar-component')) {
  customElements.define('top-bar-component', TopBarComponent);
}
